import React, { memo } from "react";
import { CircularProgress, Paper } from "@mui/material";
import Button from "../../../../componentsv2/Button";
import CardTotal from "../../Componentes/CardTotal";

import { useState, useContext } from "react";

import ModalAdicionarLote from "../ModalAdicionarLote";
import ModalConstruirLote from "../ModalContruirLote";

import { Context as PermissoesContext } from "../../../../Context/PermissoesContext";

import "./styles.css";
import "../styles.css";

function formatarMoeda(valor) {
  return Number(valor || 0).toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

function ResumoLote({
  titulo,
  quantidade,
  valor,
  principal = false,
  status = "",
  loading = false,
}) {
  return (
    <div
      className={`lotes-resumo-item${principal ? " lotes-resumo-item-principal" : ""}${
        status ? ` lotes-resumo-item-${status}` : ""
      }`}
    >
      <span>{titulo}</span>
      {loading ? (
        <CircularProgress size={18} aria-label={`Carregando ${titulo}`} />
      ) : (
        <>
          <strong>{quantidade ?? 0}</strong>
          <small>{formatarMoeda(valor)}</small>
        </>
      )}
    </div>
  );
}

function Totalizadores(props) {
  const {
    visualizacao = "legado",
    total,
    totalSoftlabFiltrado,
    loadingGeradoSoftlab,
    listaConvenios,
    setAtualizaTabelaFaturamento,
    dadosTabelaFaturamento = [],
  } = props;

  const [modalNovoLote, setNovoLote] = useState(false);
  const [modalConstruirLote, setConstruirLote] = useState(false);

  const handleOpenModal = () => setNovoLote(true);
  const handleCloseModal = () => setNovoLote(false);

  const handleOpenConstruir = () => setConstruirLote(true);
  const handleConstruirModal = () => setConstruirLote(false);

  const { checarPermissaoSemLog } = useContext(PermissoesContext);
  const novaVisualizacao = visualizacao === "lotes";
  const naoEnviado = novaVisualizacao
    ? Number(total?.somaTotal || 0) - Number(total?.somaTotalEnviado || 0)
    : parseInt(total.somaTotal, 10) - parseInt(total.somaTotalEnviado, 10);
  const situacoes = [
    { key: "TODOS", label: "Todos", className: "todos" },
    { key: "ABERTO", label: "Aberto", className: "aberto" },
    { key: "CONCLUIDO", label: "Concluído", className: "concluido" },
    { key: "PREPARANDO_XML", label: "Preparando XML", className: "preparando" },
    { key: "ENVIADO", label: "Enviado", className: "enviado" },
    { key: "PENDENCIA", label: "Pendência", className: "pendencia" },
  ];
  const resumoSituacoes = situacoes.map(situacao => {
    const itens = situacao.key === "TODOS"
      ? dadosTabelaFaturamento
      : dadosTabelaFaturamento.filter(item => (item.status || "ABERTO") === situacao.key);
    return {
      ...situacao,
      quantidade: itens.length,
      valor: itens.reduce((soma, item) => soma + Number(item.valor || 0), 0),
    };
  });

  return (
    <Paper
      className={`container_totalizadores${
        novaVisualizacao ? " container_totalizadores-lotes" : ""
      }`}
      sx={
        novaVisualizacao
          ? { padding: "0.85rem 1.25rem" }
          : undefined
      }
    >
      {novaVisualizacao ? (
        <div className="lotes-resumo-financeiro" aria-label="Resumo dos lotes">
          {resumoSituacoes.map(situacao => (
            <ResumoLote
              key={situacao.key}
              titulo={situacao.label}
              quantidade={situacao.quantidade}
              valor={situacao.valor}
              principal={situacao.key === "TODOS"}
              status={situacao.className}
            />
          ))}
        </div>
      ) : (
        <>
          <CardTotal
            titulo="Gerado Softlab"
            valor={totalSoftlabFiltrado}
            loadingGeradoSoftlab={loadingGeradoSoftlab}
          />

          <CardTotal titulo="Loteado" valor={total.somaTotal} />
          <CardTotal titulo="Enviado" valor={total.somaTotalEnviado} />

          {/* <CardTotal
            titulo="Recebido"
            valor={total.somaTotalRecebido}
          /> */}
          <CardTotal titulo="Não enviado" valor={naoEnviado} />
        </>
      )}

      {checarPermissaoSemLog("FAT012") ? (
        novaVisualizacao ? (
          <div className="lotes-acoes" aria-label="Ações de lote">
            <Button
              color="blue"
              variant="outlined"
              onClick={handleOpenModal}
              className="lotes-acao-secundaria"
            >
              Adicionar Lote
            </Button>
            <Button
              color="blue"
              variant="contained"
              onClick={handleOpenConstruir}
              className="lotes-acao-primaria"
              title="Construir Lote"
            >
              Construir Lote
            </Button>
          </div>
        ) : (
          <>
            <Button color="blue" variant="outlined" onClick={handleOpenModal}>
              Adicionar Lote
            </Button>
            <Button
              color="orange"
              variant="contained"
              onClick={handleOpenConstruir}
            >
              Construir Lote
            </Button>
          </>
        )
      ) : (
        <></>
      )}
      <ModalAdicionarLote
        open={modalNovoLote}
        handleClose={handleCloseModal}
        listaConvenios={listaConvenios}
      />
      <ModalConstruirLote
        open={modalConstruirLote}
        handleClose={handleConstruirModal}
        listaConvenios={listaConvenios}
        setAtualizaTabelaFaturamento={setAtualizaTabelaFaturamento}
      />
    </Paper>
  );
}

export default memo(Totalizadores);
